/* istanbul ignore file */
import {useState} from 'react';

type MutationCallbackType = (mutations: MutationRecord[], observer: MutationObserver) => void;

/**
 * @description Return a dom element when it will appear. No need to test browser api.
 * @param {string} id
 * @return {HTMLElement}
 */
export function useDomObserver(id: string): HTMLElement | null {
	const app = document.getElementById('app');
	const target = document.getElementById(id);
	const [node, setNode] = useState<HTMLElement | null>(target);

	const callback: MutationCallbackType = (_mutations, observer) => {
		const targetNode = document.getElementById(id);
		if (targetNode) {
			setNode(targetNode);
			observer.disconnect();
		}
	};

	if (!target && app) {
		const observer = new MutationObserver(callback);
		observer.observe(app, {
			attributes: true,
			childList: true,
			subtree: true,
		});
	} else if (target) {
		return target;
	}

	return node;
}
